<dashboardnav>
    <cradua-seismic-claim-type
    [seismicclaimtypes]="seismicclaimtypes$ | async"
    (seismicclaimtype)="onSubmitSeismicClaimType($event)"
    (deleteSeismicClaimTypeEvent)="onDeleteSeismicClaimType($event)"
    *ngIf="(isLoadingSeismicClaimType$ | async ) === false"
    >
  </cradua-seismic-claim-type>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingSeismicClaimType$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
